var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4564 14.883C25.5006 14.4583 22.4993 14.4583 19.5435 14.883C18.078 15.0936 16.9489 16.283 16.8148 17.7574L16.6878 19.1532C16.3944 22.378 16.3944 25.6227 16.6878 28.8475L16.8148 30.2432C16.9489 31.7177 18.078 32.9071 19.5435 33.1176C22.4993 33.5424 25.5006 33.5424 28.4564 33.1176C29.9219 32.9071 31.051 31.7177 31.1851 30.2432L31.3121 28.8475C31.6055 25.6227 31.6055 22.378 31.3121 19.1532L31.1851 17.7574C31.051 16.283 29.9219 15.0936 28.4564 14.883ZM21.9999 21.0003C21.9999 19.8958 22.8954 19.0003 23.9999 19.0003C25.1045 19.0003 25.9999 19.8958 25.9999 21.0003C25.9999 22.1049 25.1045 23.0003 23.9999 23.0003C22.8954 23.0003 21.9999 22.1049 21.9999 21.0003ZM19.9999 27.5003C19.9999 25.8435 21.3431 24.5003 22.9999 24.5003H24.9999C26.6568 24.5003 27.9999 25.8435 27.9999 27.5003C27.9999 28.0526 27.5522 28.5003 26.9999 28.5003H20.9999C20.4477 28.5003 19.9999 28.0526 19.9999 27.5003Z",
    fill: "#3D87BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRequests);
export default __webpack_public_path__ + "static/media/active-requests.765c27d72f48f05d4f16b913c34eea54.svg";
export { ForwardRef as ReactComponent };